import mockMachines from "./mockMachines";

const periods = ["2026-W09", "2026-W10", "2026-W11"];
const periodFactors = {
  "2026-W09": 1,
  "2026-W10": 1.06,
  "2026-W11": 0.97,
};

const lineBase = {
  Corte: 1120,
  Prensagem: 1480,
  Usinagem: 1310,
  Montagem: 1210,
};

const riskLoadFactor = {
  Baixo: 0.95,
  Médio: 1,
  Alto: 1.08,
};

const mockPlan = periods.flatMap((period, periodIndex) =>
  mockMachines.map((machine, machineIndex) => {
    const seed =
      lineBase[machine.line] *
      (periodFactors[period] || 1) *
      (riskLoadFactor[machine.riskLevel] || 1) *
      (0.92 + (machineIndex % 4) * 0.05) *
      (1 + periodIndex * 0.01);

    return {
      id: `plan_${period}_${machine.id}`,
      period,
      machineId: machine.id,
      planUnits: Math.round(seed),
    };
  })
);

export default mockPlan;
